module.exports = __webpack_public_path__ + "img/lucky-grid-center.eed99e9.png";